// NovaLand site içerik konfigürasyonu - kolayca düzenlenebilir
export const SITE = {
  brand: "NovaLand",
  tagline: "Zarafetin En Şık Hali",
  hero: {
    title: "Minimal Dokunuşlarla Zamansız Şıklık",
    subtitle: "NovaLand ile modern ve zarif aksesuarları keşfedin.",
  },
  whatsapp: {
    number: "905536245648",
    display: "+90 553 624 56 48",
    defaultMessage: "Merhaba, NovaLand ürünleri hakkında bilgi almak istiyorum.",
  },
  social: {
    instagram: "https://www.instagram.com/novalandaksesuar/",
    instagramHandle: "@novalandaksesuar",
    tiktok: "https://www.tiktok.com/@novaland.aksesuar",
    tiktokHandle: "@novaland.aksesuar",
    shopier: "https://www.shopier.com/novalandaksesuar",
  },
  account: {
    bankName: "Ziraat Bankası",
    accountHolder: "Fadime Handan Bayazıt",
    iban: "TR16 0001 0015 8753 7814 2550 12",
  },
  about: `Novaland, kaliteli ve şık çelik takıları müşterileriyle buluşturmak amacıyla kurulmuş bir aksesuar markasıdır. İki arkadaşın ortak hayali olarak başlayan bu girişim, estetik anlayışı, kalite odaklı yaklaşımı ve müşteri memnuniyetini ön planda tutan hizmet anlayışıyla bugün büyümeye devam etmektedir.

Takının, kişisel tarzı tamamlayan ve kendini ifade etmenin en zarif yollarından biri olduğuna inanıyoruz. Bu doğrultuda koleksiyonlarımızı oluştururken modern, zamansız ve günlük kullanıma uygun tasarımları özenle seçiyoruz.

Novaland bünyesinde; kolye, küpe, bileklik, yüzük, halhal ve çeşitli çelik takı kategorilerinde geniş ürün seçenekleri sunulmaktadır. Ürünlerimizin seçiminde kalite, estetik görünüm ve kullanım konforu temel önceliklerimiz arasında yer almaktadır.

Müşterilerimize güvenilir alışveriş deneyimi sunmayı, kaliteli ürünleri ulaşılabilir fiyatlarla buluşturmayı ve her geçen gün ürün yelpazemizi geliştirerek daha geniş kitlelere ulaşmayı hedefliyoruz.

Novaland, bir hayalin girişime dönüşmesiyle başlayan yolculuğunu; güven, kalite ve müşteri memnuniyeti ilkeleri doğrultusunda sürdürmektedir. Her detayında özen bulunan ürünlerimizle, tarzınıza değer katmaya devam ediyoruz.`,
  story: {
    title: "Novaland'ın Hikâyesi",
    chapters: [
      {
        heading: "Bir Hayalle Başladı",
        text: "Novaland, hayallerini gerçeğe dönüştürmek isteyen iki arkadaşın ortak hikâyesidir. Bir gün sadece bir hayal olarak başlayan bu yolculuk, kadınların kendilerini özel hissetmelerini sağlayacak şık ve kaliteli takıları bir araya getirme fikriyle hayat buldu.",
      },
      {
        heading: "Tek Çatı Altında",
        text: "Takılara olan sevgimizi, estetik anlayışımızı ve girişimcilik hayalimizi tek bir markada buluşturmak istedik. İşte Novaland böyle doğdu.",
      },
      {
        heading: "Koleksiyonlarımız",
        text: "Bugün Novaland olarak; kolye, küpe, bileklik, yüzük, halhal ve daha birçok çelik takı modelini sizlerle buluşturuyoruz. Koleksiyonlarımızı oluştururken hem günlük kullanıma uygun hem de tarzınızı tamamlayacak modern ve zamansız parçalar seçmeye özen gösteriyoruz.",
      },
      {
        heading: "Bir Yansıma",
        text: "Bizim için takılar sadece bir aksesuar değil; kendini ifade etmenin, özgüvenin ve zarafetin küçük ama güçlü bir yansımasıdır. Her ürünün, kullanan kişiye kendini özel hissettirmesini amaçlıyoruz.",
      },
      {
        heading: "Birlikte Büyüyoruz",
        text: "Novaland, iki arkadaşın cesaretle attığı bir adımın, emekle büyüyen bir markaya dönüşme hikâyesidir. Yolculuğumuzun en güzel yanı ise bu hikâyenin bir parçası olan sizlerle birlikte büyümeye devam etmektir.",
      },
    ],
    closing: "Sevgiyle seçilen her detayda, kurduğumuz hayalin bir parçasını bulacaksınız. Novaland'a hoş geldiniz.",
  },
  features: [
    { icon: "Gem", title: "Modern Tasarımlar", text: "Trendleri yakalayan, zamansız parçalar." },
    { icon: "Sparkles", title: "Zarif ve Minimal", text: "Sade çizgilerle her stile uyumlu." },
    { icon: "Truck", title: "Türkiye Geneli Kargo", text: "Hızlı ve güvenli teslimat ağı." },
    { icon: "MessageCircle", title: "WhatsApp Destek", text: "Anlık iletişim, kişisel öneri." },
    { icon: "Heart", title: "Müşteri Memnuniyeti", text: "Sevgiyle paketlenen her sipariş." },
    { icon: "ShieldCheck", title: "Kaliteli Çelik", text: "Solmaz, kararmaz, uzun ömürlü." },
  ],
  faq: [
    {
      q: "Sipariş nasıl verebilirim?",
      a: "WhatsApp hattımızdan ürün adı veya kodunu bize iletmeniz yeterli. Size sipariş akışını hemen aktarıyoruz. Dilerseniz Shopier mağazamızdan da güvenle alışveriş yapabilirsiniz.",
    },
    {
      q: "Kargo süresi ne kadar?",
      a: "Siparişiniz onaylandıktan sonra 1-2 iş günü içinde özenle hazırlanır. Türkiye geneline ortalama 2-4 iş günü içinde teslim edilir.",
    },
    {
      q: "Hangi materyaller kullanılıyor?",
      a: "Tüm koleksiyonlarımız kararma ve solmaya karşı dayanıklı, hipoalerjenik çelik altyapı üzerine işlenmiştir. Günlük kullanıma uygundur.",
    },
    {
      q: "WhatsApp üzerinden destek alabilir miyim?",
      a: "Elbette. WhatsApp hattımız hafta içi 10:00 – 19:00 arası aktiftir. Ürün seçimi, kombin önerisi ve sipariş takibi için bize yazabilirsiniz.",
    },
    {
      q: "İade ve değişim koşulları nelerdir?",
      a: "Hijyenik kullanım koşulları gözetilerek, teslim tarihinden itibaren 14 gün içinde değişim ve iade talebinde bulunabilirsiniz. Ürünün etiketi ve ambalajı bozulmamış olmalıdır.",
    },
  ],
};
